import { useEffect } from "react";
import { api } from "@/lib/api";

export function trackEvento(evento, pantalla) {
  api.post("/eventos", { evento, pantalla }).catch(() => {});
}

export function useTrackScreenView(pantalla) {
  useEffect(() => {
    trackEvento("pantalla_vista", pantalla);
  }, [pantalla]);
}
